import PropTypes from "prop-types";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

/**
 * Batch 2.3 — <LifecycleActions>. The Save + Publish/Unpublish/Archive button
 * row at the foot of <ContentForm>. Lifecycle buttons stay disabled until the
 * content has been saved once (a `contentId` exists).
 */
function LifecycleActions({
  status,
  contentId,
  saving,
  busy,
  onSave,
  onPublish,
  onUnpublish,
  onArchive,
}) {
  const hasId = Boolean(contentId);

  return (
    <MDBox>
      <MDBox display="flex" gap={1} flexWrap="wrap">
        <MDButton color="info" variant="gradient" onClick={onSave} disabled={saving || busy}>
          {saving ? "Saving…" : "Save"}
        </MDButton>

        {status !== "published" && (
          <MDButton
            color="success"
            variant="outlined"
            onClick={onPublish}
            disabled={!hasId || saving || busy}
          >
            Publish
          </MDButton>
        )}

        {status === "published" && (
          <MDButton
            color="warning"
            variant="outlined"
            onClick={onUnpublish}
            disabled={!hasId || saving || busy}
          >
            Unpublish
          </MDButton>
        )}

        {status !== "archived" && (
          <MDButton
            color="error"
            variant="outlined"
            onClick={onArchive}
            disabled={!hasId || saving || busy}
          >
            Archive
          </MDButton>
        )}
      </MDBox>

      {!hasId && (
        <MDTypography variant="caption" color="text" mt={1} display="block">
          Save the content first to enable publishing.
        </MDTypography>
      )}
    </MDBox>
  );
}

LifecycleActions.defaultProps = {
  status: "draft",
  contentId: null,
  saving: false,
  busy: false,
};

LifecycleActions.propTypes = {
  status: PropTypes.string,
  contentId: PropTypes.string,
  saving: PropTypes.bool,
  busy: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
  onUnpublish: PropTypes.func.isRequired,
  onArchive: PropTypes.func.isRequired,
};

export default LifecycleActions;
